module.exports = __webpack_public_path__ + "img/1110.06cbd0c3.svg";